import type { AssetFile } from '@main/pc-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { aboutTranscendWidgetMessages } from './messages';
import { DefaultWidget, ImageWidget, StyledA, TextWrapper } from './wrappers';

/**
 * Props for the About Transcend widget component
 */
export interface AboutTranscendWidgetProps {
  /** Background image for widget, otherwise defaults to secondary color */
  asset?: AssetFile;
  /** The link to About Transcend Privacy Center and how it works */
  aboutTranscendUri?: string;
}

/**
 * A widget that directs the user to review how the privacy center works
 */
function AboutTranscendWidget({
  asset,
  aboutTranscendUri = '/about',
}: AboutTranscendWidgetProps): JSX.Element {
  const { formatMessage } = useIntl();
  const content = (
    <React.Fragment>
      <TextWrapper>
        {formatMessage(aboutTranscendWidgetMessages.aboutTranscend)}
      </TextWrapper>
      <StyledA href={aboutTranscendUri} external>
        {formatMessage(aboutTranscendWidgetMessages.buttonMessage)}
      </StyledA>
    </React.Fragment>
  );

  return asset ? (
    <ImageWidget asset={asset.src}>{content}</ImageWidget>
  ) : (
    <DefaultWidget>{content}</DefaultWidget>
  );
}

export default AboutTranscendWidget;
